export default __webpack_public_path__ + "static/media/voxologic_dialer_logo.a84be462.png";